export enum AccessType {
  AUTHORISED = 'AUTHORISED',
  UNAUTHORISED = 'UNAUTHORISED',
  INCORRECT_ADVERTISER = 'INCORRECT_ADVERTISER',
  NOT_FOUND = 'NOT_FOUND',
}

/**
 * Enums copied from hirer graph as the `postChannel` field is a `String!`.
 * See https://github.com/SEEK-Jobs/hirer-graphql-api/blob/e4d0967c89165a4fb2731ff1211bd80f0c7a38d2/src/schema/job/type.ts#L11-L15
 */
export enum JobPostChannel {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
  IMPORT = 'IMPORT',
}
